module.exports = __webpack_public_path__ + "static/media/autre-iv.09fac53e.jpg";